import React from 'react';

export const IncrementalModule = React.forwardRef( () => {
  return null;
} );

export const displayName = 'IncrementalModule';

export default IncrementalModule;